import React from 'react';
import "./Withdraw_History_card.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';

function Withdraw_History_card({ imgSrc, title, description, amount, status, time }) {
    return (
        <section className='Withdraw_History_card'>
            <div className="card_holder">
                <div className="img_holder">
                    <img src={imgSrc} alt={title} className='wallet_card_img' />
                </div>

                <div className='text_ammount_holder'>
                    <div className="text_holder">
                        <h6>{title}</h6>
                        <p>{description}</p>
                    </div>
                    <div className="amount_holder">
                        <h6>₹ {amount}</h6>
                        <p className={status.toLowerCase()}>{status}</p>
                    </div>
                </div>
            </div>
            <div className="time_note_holder">
                <span><FontAwesomeIcon icon={faClock} /> {time}</span>
            </div>
        </section>
    );
}

export default Withdraw_History_card;
